// Функция которая возвращает позицию тикета в списке тикетов.
// Она учитывает statusWeight, сортировку глобальную(ASC, DESC),
// сортировку локальную для каждого статуса.
// Изменить вес статуса или локальную сортировку можно в https://level.travel/admin/crm_ticket_statuses
import { findIndex, isEmpty } from 'lodash';

const getTicketPosition = ({
  tickets,
  newTicket,
  order = 'ASC',
  lastPage = true,
}) => {
  if (isEmpty(tickets)) return 0;

  const { ticket: newTicketData } = newTicket;
  let shift = 0;
  const position = findIndex(tickets, ({ ticket: ticketData }, index) => {
    const nextTicket = tickets[index + 1];
    if (!nextTicket) {
      if (lastPage) {
        shift += 1;
        return true;
      }
      return false;
    }

    const { ticket: nextTicketData } = nextTicket;

    if (newTicketData.statusWeight > ticketData.statusWeight) {
      return true;
    }

    if (
      newTicketData.statusWeight < ticketData.statusWeight &&
      newTicketData.statusWeight > nextTicketData.statusWeight
    ) {
      shift += 1;
      return true;
    }

    return false;
  });

  return position + shift;
};

export default getTicketPosition;
